function setHeaderSpacerHeight() {
    var header = document.querySelector('header');
    var headerContainer = document.querySelector('.section-header');
    var headerSpacer = document.querySelector('.header-spacer');

    if (header && headerSpacer) {
        headerContainer.style.height = window.getComputedStyle(header).height;
        headerSpacer.style.height = window.getComputedStyle(header).height;
    }

    if (document.querySelector('.appstle-wrapper')) {
        if (window.innerWidth > 990) {
        headerSpacer.style.display = 'block';
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    setHeaderSpacerHeight();
});

window.onresize = function () {
    setHeaderSpacerHeight();
};
